import { render, staticRenderFns } from "./AddPartnerButton.vue?vue&type=template&id=e479dce2&scoped=true&"
import script from "./AddPartnerButton.vue?vue&type=script&lang=ts&"
export * from "./AddPartnerButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddPartnerButton.vue?vue&type=style&index=0&id=e479dce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e479dce2",
  null
  
)

export default component.exports